import { createFileRoute, redirect } from "@tanstack/react-router";
import { needsOnboarding } from "@/lib/onboarding";
import { resolvePostLoginDestination } from "@/lib/post-login-redirect";

export const Route = createFileRoute("/post-login")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: typeof search.redirect === "string" ? search.redirect : "",
  }),
  beforeLoad: async ({ search }) => {
    const res = await fetch("/api/me/profile");
    if (!res.ok) throw redirect({ to: "/login" });
    const profile = await res.json();
    const dest = resolvePostLoginDestination(search.redirect as string, profile.role);
    if (needsOnboarding(profile)) {
      throw redirect({ to: "/onboarding", search: { redirect: dest, gate: "" } });
    }
    throw redirect({ to: dest });
  },
  component: () => null,
});
